function cat(...args) {
  return args.join('');
}

export default cat;
